<div class="modal-header">
  <h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Board': 'New Board' }} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="alert-danger" *ngIf="errMsg">
    {{errMsg}}
  </div>
  <form name="form" #f="ngForm" novalidate>
    <div class="form-group">
      <label class="rbv-label">Name</label>
      <input type="text" specialIsAlphaNumeric maxlength="50" name="NAME" [(ngModel)]="board.NAME" #NAME="ngModel"
             class="rbv-field form-control rounded-0" [ngClass]="{ 'is-invalid': f.submitted && NAME.invalid }" required>
      <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
        <div *ngIf="NAME.errors.required">Name is required</div>
      </div>
    </div>

    <div class="form-group">
      <input class="checkbox-custom" type='checkbox' name="askModal" id="shared" [checked]="false"
             [(ngModel)]="board.SHARED" />
      <label class="checkbox-custom-label" for="shared">
        Share to all users
      </label>
    </div>
  </form>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button [disabled]="!f.form.valid" type="button" class="btn btn-rbv"
          (click)="onSubmit()">{{ isEdit ? 'Save': 'Create' }} </button>
</div>
